import { useEffect, useState } from 'react';

import axiosInstance from '../utils/axiosConfig';
import useTranslation from '../utils/useTranslation';

export default function useLawsData() {
  const { lang } = useTranslation();
  const [laws, setLaws] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axiosInstance
      .get('public/laws-regulations/', { params: { lang } })
      .then((res) => {
        if (!cancelled) setLaws(res.data?.laws_regulations || []);
      })
      .catch(() => {
        if (!cancelled) setLaws([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [lang]);

  return { laws, loading };
}

/** Find a content row (and its parent law) by content id across the laws list. */
export function findLawContent(laws, contentId) {
  const id = Number(contentId);
  if (!id) return null;
  for (const law of laws) {
    const content = (law.contents || []).find((c) => c.id === id);
    if (content) return { law, content };
  }
  return null;
}
